<template>
  <section class="activity-card">
    <router-link :to="`/article/detail/${item.id}`">
      <div class="left">
        <h4>{{item.title}}</h4>
        <p v-html="delHtmlTag(item.content)"></p>
        <div class="info" :class="{'userType2':item.userType === 2 && item.isCertification === 1}">
          <img
            @click.stop.prevent="myCenter"
            :src="item.userAvatar| imageUrl('/static/profile_img_default.png',60,60)"
            alt
          />
          <span @click.stop.prevent="myCenter" class="nickname">{{item.userNickName}}</span>
          <div class="createTime">
            <span class="time">{{item.articleReleaseTime | dateToNow(language)}}</span>
            <!-- <img src="/static/home/images/eyes.png" />
            <span class="view">{{item.viewCount}}</span>-->
          </div>
        </div>
      </div>
      <div class="right" v-if="image">
        <img :src="image| imageUrl('',356,200)" alt />
      </div>
    </router-link>
  </section>
</template>

<script>
export default {
  props: ["item", "topicId"],
  data() {
    return {};
  },
  computed: {
    image() {
      let src = "";
      const imageList = this.item.content.match(/<img[^>]*>/);
      if (imageList && imageList.length) {
        imageList[0].replace(/src="([^"]*)"/, (a, b) => (src = b));
      }
      return src;
    },
    language() {
      return this.$language();
    }
  },
  methods: {
    myCenter() {
      this.$router.push(`/peopleCenter/${this.item.userId}`);
    }
  }
};
</script>

<style lang="stylus" scoped>
.activity-card {
  cursor: pointer;

  a {
    display: flex;
    flex-direction: row;

    .left {
      flex: 1;

      h4 {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #0A0A0A;
        padding-bottom: 12px;
      }

      &>p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999;
        line-height: 20px;
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      div.info {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 12px;
        position: relative;

        &.userType2::before {
          content: '';
          left: 20px;
          bottom: 0;
          position: absolute;
          width: 10px;
          height: 10px;
          background: url('/static/v2/match/Verified_icon_blue_20.png');
          background-size: 10px;
        }

        img {
          width: 30px;
          height: 30px;
          border-radius: 15px;
          margin-right: 8px;
        }

        .nickname {
          font-size: 12px;
          color: #333;

          &:hover {
            color: #0A0A0A;
          }
        }

        .createTime {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding-left: 30px;
          font-size: 12px;
          font-family: NunitoSans-Regular, NunitoSans;
          font-weight: 400;

          span {
            color: #B8B8B8;
            padding-right: 30px;
          }

          img {
            width: 14px;
            height: 10px;
            padding-right: 5px;
          }
        }
      }
    }

    .right {
      width: 178px;
      margin-left: 10px;

      img {
        width: 178px;
        height: 100px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/match/activityCard.vue